import $ from "jquery";
import Plyr from 'plyr';

const playerId = document.getElementsByClassName("ambient-hero");

if (playerId && playerId.length > 0) {
    initAmbientHero();
}

function initAmbientHero(){
    const player = new Plyr(".ambient-hero" ,{
        autoplay: true,
        muted: true,
        loop: { active: true
        },
        displayDuration: false,
        hideControls: false,
        storage: false,
        controls: [
            "play",
            "mute",
        ]
    });

    // pause the video when media query goes to small (<640px)
    $(window).on("changed.zf.mediaquery", function(event, newSize, oldSize) {
        if (newSize === "small") {
            player.pause();
        } else {
            player.play();
        }
    });
}
window.initAmbientHero = initAmbientHero;


/**
 * Initializes the shea video players
 */
function initSheaVideoPlyr() {
    //Setting up multiple Plyr videos using shea-video class
    Array.from(document.querySelectorAll('.shea-video')).map(function (player) {
        if (player){
            setTimeout(function () {
                return new Plyr(player);
              }, 300); 
        }
    });
}
window.initSheaVideoPlyr = initSheaVideoPlyr;


/**
 * Initializes the reveal video players
 */
function initRevealVideoPlyr() {
    //Setting up multiple Plyr videos using reveal-video class
    Array.from(document.querySelectorAll('.reveal-video')).map(function (player) {
        if (player){
            setTimeout(function () {
                return new Plyr(player,{autoplay: true});
              }, 300); 
        }
    });
}
window.initRevealVideoPlyr = initRevealVideoPlyr;
